module.exports = __webpack_public_path__ + "static/media/class_job_037.45235fad.svg";